import { PER_POST_ID } from "../constant/ActionType";

export default function PostPreDataReduncers(
  state = {
    predatapost: [],
    statusCode: null,
  },
  action
) {
  switch (action.type) {
    case PER_POST_ID:
      return {
        ...state,
        predatapost: action.data,
        statusCode: action.status,
      };

    default:
  }

  return state;
}
